module.exports = __webpack_public_path__ + "b7ea1988e974ddfe1e94a8baf126d8b9.svg";